import React, { useEffect, useState } from "react";
import { apiService, handleApiError } from "../../services/axiosService";
import Loader from "../../Layouts/Loader/Loader";
import BuilderTable from "../../Layouts/BuilderTable";
import Pagination from "../ApplicationUsers/Pagination";
import SingleSelectBox from "../../components/FormComponents/SingleSelectBox";

const DEFAULT_LIMIT = 10;

const ACTION_OPTIONS = [
  { id: "", name: "All Actions" },
  { id: "assign", name: "Assign" }
];

const SOURCE_PILL_STYLES = {
  login_saml: { background: "#ede9fe", color: "#5b21b6", border: "1px solid #c4b5fd" },
  login_email: { background: "#dbeafe", color: "#1e40af", border: "1px solid #93c5fd" }
};

const DEFAULT_PILL_STYLE = { background: "#f3f4f6", color: "#374151", border: "1px solid #d1d5db" };

const SOURCE_LABELS = {
  login_saml: "SAML",
  login_email: "Email"
};

const formatDateTime = (value) => {
  if (!value) return "-";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;
  return date.toLocaleString();
};

const AppAssignmentAudit = () => {
  const [logs, setLogs] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [pagination, setPagination] = useState({ page: 1, limit: DEFAULT_LIMIT });
  const [filters, setFilters] = useState({ action: "" });
  const [pageTrack, setPageTrack] = useState({ currPage: 1, totalPages: 1 });
  const [orgMap, setOrgMap] = useState({});

  useEffect(() => {
    apiService
      .get("/organisations")
      .then((res) => {
        const map = {};
        (res?.data || []).forEach((org) => {
          map[org.id] = org.name;
        });
        setOrgMap(map);
      })
      .catch(console.error);
  }, []);

  const fetchLogs = async (page = pagination.page, limit = pagination.limit, nextFilters = filters) => {
    try {
      setIsLoading(true);

      const params = {
        page,
        limit,
        action: nextFilters.action || undefined
      };

      const response = await apiService.get("/audit/app-assignments", { params });

      const audits = response?.data?.audits || [];
      const total = response?.data?.total || 0;

      setLogs(
        audits.map((log) => ({
          id: log.id,
          action: (
            <span
              className="status_pill"
              style={{ background: "#dcfce7", color: "#166534", border: "1px solid #86efac" }}
            >
              Assign
            </span>
          ),
          appName: log.app_name || "-",
          orgName: orgMap[log.org_id] || "-",
          userName: log.user_name || "-",
          userEmail: log.user_email || log.user_upn || "-",
          source: (
            <span className="status_pill" style={SOURCE_PILL_STYLES[log.source] || DEFAULT_PILL_STYLE}>
              {SOURCE_LABELS[log.source] || log.source || "-"}
            </span>
          ),
          createdAt: formatDateTime(log.created_at)
        }))
      );

      setPageTrack({
        currPage: response?.data?.page || page,
        totalPages: Math.ceil(total / limit) || 1
      });
    } catch (error) {
      handleApiError(error);
      setLogs([]);
      setPageTrack({ currPage: 1, totalPages: 1 });
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchLogs(pagination.page, pagination.limit, filters);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.page, pagination.limit, filters]);

  const columns = [
    { key: "action", header: "Action" },
    { key: "appName", header: "Application" },
    { key: "orgName", header: "Organization" },
    { key: "userName", header: "User Name" },
    { key: "userEmail", header: "User Email" },
    { key: "source", header: "Source" },
    { key: "createdAt", header: "Created At" }
  ];

  return (
    <div className="h_100 w_100 p_2">
      <h2 className="m_4">System Assignment Logs</h2>
      <div className="d_flex justify_between gap_3 px_5 pb_3">
        <div style={{ minWidth: "220px" }}>
          <SingleSelectBox
            options={ACTION_OPTIONS}
            valueKey="id"
            labelKey="name"
            selectedData={filters.action}
            onChange={(opt) => {
              setFilters({ action: opt?.id || "" });
              setPagination((prev) => ({ ...prev, page: 1 }));
            }}
            placeholder="Select Action"
          />
        </div>
      </div>

      {isLoading ? (
        <Loader width={70} />
      ) : (
        <div className="org-dashboard-page-body" style={{ height: "calc(100% - 160px)" }}>
          <BuilderTable
            columns={columns}
            data={logs}
            noDataMessage="No System Assignment Logs Found"
            style={{ tableLayout: "auto", minWidth: "900px" }}
          />
          <div className="p_3 bottom_border">
            <Pagination
              pageTrack={pageTrack}
              pagination={pagination}
              onPageChange={(p) => setPagination((prev) => ({ ...prev, page: p }))}
              onLimitChange={(l) => setPagination({ page: 1, limit: l })}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default AppAssignmentAudit;
